const baseMetaConfig = [
  { name: 'viewport', content: 'width=device-width, initial-scale=1' },
  { name: 'format-detection', content: 'telephone=no' },
  { 'http-equiv': 'x-ua-compatible', 'content': 'IE=edge' },
  { name: 'apple-mobile-web-app-capable', content: 'yes' },
  { name: 'apple-mobile-web-app-status-bar-style', content: 'default' },
  { name: 'apple-mobile-web-app-title', content: 'IhreApotheken.de' },
  { name: 'mobile-web-app-capable', content: 'yes' },
  { name: 'msapplication-TileColor', content: '#FFFFFF' },
  { name: 'theme-color', content: '#FFFFFF' },
  { name: 'google-site-verification', content: 'R_ZRx3puBEh6NEHEtGWijHRXPuRFEWrob6qRCHdqX3o' },

  // Open Graph
  { property: 'og:type', content: 'website' },
  { property: 'og:site_name', content: 'IhreApotheken.de' },
  { property: 'fb:app_id', content: '156923662622388' },
  { name: 'twitter:card', content: 'summary' },
  { name: 'twitter:site', content: '@ihreapotheken' },
]

const baseLinkConfig = [
  { rel: 'dns-prefetch', href: 'https://www.google-analytics.com' },
  { rel: 'dns-prefetch', href: 'https://maps.googleapis.com' },
  { rel: 'dns-prefetch', href: 'https://www.googletagmanager.com' },
  { rel: 'dns-prefetch', href: 'https://walker.p.elbwalkerapis.com' },
  { rel: 'dns-prefetch', href: 'https://static.hotjar.com' },
  { rel: 'dns-prefetch', href: 'https://script.hotjar.com' },
  { rel: 'dns-prefetch', href: 'https://project-file.p.elbwalkerapis.com' },
  { rel: 'dns-prefetch', href: 'https://connect.facebook.net' },
  { rel: 'dns-prefetch', href: 'https://bat.bing.com' },
  { rel: 'dns-prefetch', href: 'https://az416426.vo.msecnd.net' },
  { rel: 'dns-prefetch', href: 'https://az416426.vo.msecnd.net' },
  { rel: 'manifest', crossorigin: 'use-credentials', href: '/manifest.json' },
  { href: 'https://www.googletagmanager.com', rel: 'preconnect', crossorigin: 'anonymous' },
  { href: 'https://images.ihreapotheken.de', rel: 'preconnect', crossorigin: 'anonymous' },
  { href: 'https://img.ihreapotheken.de', rel: 'preconnect', crossorigin: 'anonymous' },
  { rel: 'preconnect', href: '//app.usercentrics.eu' },
  { rel: 'preconnect', href: '//api.usercentrics.eu' },
  { rel: 'preload', href: '//app.usercentrics.eu/browser-ui/latest/loader.js', as: 'script' },
]

export { baseMetaConfig, baseLinkConfig }
